export function hidePassword(password) {
  if (!password) return '';
  if (!password.length) return '';
  return '*'.repeat(password.length);
}
